import UserService from '@/lib/User';
import { User } from '@/lib/User/types';
import { useQuery } from '@tanstack/react-query';

export interface CurrentUser extends User {
  canShowTradingFeatures?: boolean
  isVerifiedStudent?: boolean
  isOnboardingComplete?: boolean
}

export default function useCurrentUser(enabled = true) {
  const query = useQuery<CurrentUser | null>({
    queryKey: ['user'],
    queryFn: async (): Promise<CurrentUser | null> => {
      const data = await UserService.getUser(true);
      if (!data) return null;
      return {
        ...data,
        canShowTradingFeatures: !!data?.account?.sponsorId,
        isVerifiedStudent: data?.account?.isStudent === true,
        isOnboardingComplete: !!data?.account?.name && !!data?.account?.email && !!data?.account?.birthday,
      };
    },
    staleTime: 12 * 60 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
    enabled
  });

  return query
}
